import { isAbortError } from "abort-controller-x";
import { ClientError, Status } from "nice-grpc-web";
import { ENV } from "../../../config/env.js";
import { loggerApp } from "../../../lib/logger/index.js";
function loggerMiddleware({ successCallback, errorCallback }) {
  return async function* closedMiddleware(call, options) {
    const {
      request,
      method: { path }
    } = call;
    if (!ENV.IS_PRODUCTION) {
      loggerApp.log([
        {
          type: "info",
          message: "GRPC",
          items: [
            {
              message: `Client call: ${path}`
            },
            {
              message: `Request:`,
              items: [
                {
                  message: request
                }
              ]
            }
          ]
        }
      ]);
    }
    try {
      const result = yield* call.next(request, options);
      if (!ENV.IS_PRODUCTION) {
        loggerApp.log([
          {
            type: "success",
            message: "GRPC",
            items: [
              {
                message: `Client received: ${path}`
              },
              {
                message: `Request:`,
                items: [
                  {
                    message: request
                  }
                ]
              },
              {
                message: `Response:`,
                items: [
                  {
                    message: result
                  }
                ]
              }
            ]
          }
        ]);
      }
      successCallback == null ? void 0 : successCallback();
      return result;
    } catch (error) {
      let errorMessage;
      if (error instanceof ClientError) {
        errorMessage = `status "${Status[error.code]}", ${error.details}`;
      } else if (isAbortError(error)) {
        errorMessage = `request canceled`;
      } else {
        errorMessage = (error == null ? void 0 : error.stack) ?? "unknown error";
      }
      if (!ENV.IS_PRODUCTION) {
        loggerApp.log([
          {
            type: "error",
            message: "GRPC",
            items: [
              {
                message: `Client received: ${path}`
              },
              {
                message: `Request:`,
                items: [
                  {
                    message: request
                  }
                ]
              },
              {
                message: `Error: ${errorMessage}`
              }
            ]
          }
        ]);
      }
      errorCallback == null ? void 0 : errorCallback(error);
      throw error;
    }
  };
}
export {
  loggerMiddleware
};
